import WindowInterface from "Interfaces/WindowInterface"

// @ts-ignore
let globals: WindowInterface = window
export default globals